module.exports = __webpack_public_path__ + "img/home-cont.b36ab2d.png";